// @ts-strict-ignore
import {emitTrackEvent} from 'common/util/dom';

import type {PropertyItemWithValue} from './index';

const cancelable = true;

export function trackUploadComplete({
  el,
  fileSize,
  isNewLookupTable,
  numberOfRowsProcessed,
  numberOfRowsUploaded,
  uploadStatus,
  uploadStatusReason,
  timeToGetUrl,
  timeToUpload,
  timeToProcess,
  totalTime,
  numColumns,
  dataGroupId,
  source,
  deferMarkReady,
}) {
  const eventName = `[Lookup table] Upload complete`;
  const props = {
    Status: uploadStatus,
    'Status reason': uploadStatusReason,
    '# of rows uploaded': numberOfRowsUploaded,
    '# of rows processed': numberOfRowsProcessed,
    'File size': fileSize,
    'New table': isNewLookupTable,
    'Time to get upload url': timeToGetUrl,
    'Time to upload to GCS': timeToUpload,
    'Time to super import': timeToProcess,
    'Time to upload': totalTime,
    numColumns,
    source,
    'Table dataGroupId': dataGroupId,
    'Defer mark ready': deferMarkReady,
  };
  emitTrackEvent(el, {eventName, props, cancelable});
}

export function trackSelectTable(
  el,
  {dataGroupId, source, isNewTable}: {dataGroupId: string; source: string; isNewTable: boolean},
) {
  const eventName = `[Lookup table] Select table`;
  const props = {'New table': isNewTable, 'Table dataGroupId': dataGroupId, source};
  emitTrackEvent(el, {eventName, props, cancelable});
}

export function trackInfoClick(el, {source}) {
  const eventName = `[Lookup table] Learn more about lookup tables`;
  const props = {source};
  emitTrackEvent(el, {eventName, props, cancelable});
}

export function trackUploadMarkedReady(el, {dataGroupId, source}) {
  const eventName = `[Lookup table] Upload marked ready`;
  const props = {'Table dataGroupId': dataGroupId, source};
  emitTrackEvent(el, {eventName, props, cancelable});
}

export function trackEphemeralMappingComplete(
  el,
  {
    dataGroupId,
    source,
    isNewTable,
    property,
  }: {dataGroupId: string; source: string; isNewTable: boolean; property: PropertyItemWithValue},
) {
  const eventName = `[Lookup table] Ephemeral mapping complete`;

  const props = {
    'Property type': property.resourceType,
    'Property name': property.value,
    'Override saved mapping': Boolean(property.dimensionDataGroupId),
    'New table': isNewTable,
    'Table dataGroupId': dataGroupId,
    source,
  };
  emitTrackEvent(el, {eventName, props, cancelable});
}

export function trackImportComplete(
  el,
  {dataGroupId, source, property}: {dataGroupId: string; source: string; property: PropertyItemWithValue | EmptyObj},
) {
  const eventName = `[Lookup table] Import table complete`;
  const props = {
    'Mapped to property': Boolean(property?.value),
    'Mapped property type': property?.resourceType,
    'Mapped property name': property?.value,
    'Table dataGroupId': dataGroupId,
    source,
  };
  emitTrackEvent(el, {eventName, props, cancelable});
}
